import React, { useState, useEffect } from "react";
import { MapPin, Calendar, Link, X, Plus } from "lucide-react";

export default function AdminConcerts() {
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [upcoming, setUpcoming] = useState([]);
  const [past, setPast] = useState([]);

  const [formData, setFormData] = useState({
    date: "",
    date_end: "",
    title: "",
    desc: "",
    loc: "",
    link: ""
  });

  useEffect(() => {
    fetchConcerts();
  }, []);

  const fetchConcerts = async () => {
    const res = await fetch("/api/admin/concerts/concerts.php");
    const concerts = await res.json();

    setUpcoming(concerts.upcoming || []);
    setPast(concerts.past || []);
  };

  async function handleSubmit(e) {
    e.preventDefault();

    const url = editingId
      ? "/api/admin/concerts/edit_concert.php"
      : "/api/admin/concerts/add_concert.php";

    const payload = editingId ? { ...formData, id: editingId } : formData;

    await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });

    fetchConcerts();
    resetForm();
  }

  function resetForm() {
    setShowForm(false);
    setEditingId(null);
    setFormData({
      date: "",
      date_end: "",
      title: "",
      desc: "",
      loc: "",
      link: ""
    });
  }

  function editConcert(concert) {
    setFormData(concert);
    setEditingId(concert.id);
    setShowForm(true);
  }

  async function deleteConcert(id) {
    if (!window.confirm("Supprimer ce concert ?")) return;

    await fetch("/api/admin/concerts/delete_concert.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id })
    });

    fetchConcerts();
  }

  return (
    <section>
      <div>
                <div className="container-xl">
                  <div className="bg-white rounded shadow p-4">
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <h1 className="cat-title h3 fw-bold text-dark d-flex align-items-center gap-2">
                          <Calendar className="text-primary" />
                          Concerts
                        </h1>
                        <p className="text-secondary mb-0">
                          Ajouter, modifier ou supprimer des concerts
                        </p>
                        <button
                          onClick={() => {
                            setShowForm(!showForm);
                            if (showForm) {
                              setEditingId(null);
                              setFormData({
                                date: "",
                                date_end: "",
                                title: "",
                                desc: "",
                                loc: "",
                                link: ""
                              });
                            }
                          }}
                          className="btn btn-primary d-flex align-items-center gap-2 mt-2"
                        >
                          <Plus size={20} />
                          Ajouter
                        </button>
                      </div>
                    </div>
                  {showForm && (
                    <div className="bg-primary bg-opacity-10 p-4 rounded mt-4 w-100">
                      <h3 className="fw-semibold mb-3">Nouveau Concert</h3>
      
                      <form onSubmit={handleSubmit}>
                        <div className="row g-3">
                              <div className="col-12 col-md-6">
                                <label className="form-label fw-medium" htmlFor='date'>Date</label>
                                <input className="form-control" type='date' name='date' required value={formData.date} onChange={(e)=> setFormData({...formData, date: e.target.value})} />
                              </div>
                              <div className="col-12 col-md-6">
                                <label className="form-label fw-medium">Date de fin</label>

                                <div className="position-relative">

                                  <input
                                    className="form-control pe-5"
                                    type="date"
                                    name="date_end"
                                    value={formData.date_end || ""}
                                    onChange={(e) =>
                                      setFormData({ ...formData, date_end: e.target.value })
                                    }
                                  />

                                  {formData.date_end && (
                                    <button
                                      type="button"
                                      onClick={() =>
                                        setFormData({ ...formData, date_end: "" })
                                      }
                                      className="btn btn-sm position-absolute top-50 end-0 translate-middle-y me-3 p-0 border-0 bg-transparent"
                                      title="Supprimer la date de fin"
                                    >
                                      <X size={16} />
                                    </button>
                                  )}

                                </div>
                              </div>
                              <div className="col-12 col-md-6">
                                <label className="form-label fw-medium" htmlFor='title'>Titre</label>
                                <input className="form-control" type='text' name='title' required value={formData.title} onChange={(e)=> setFormData({...formData, title: e.target.value})}>
                                </input>
                              </div>
                              <div className="col-12 col-md-6">
                                <label className="form-label fw-medium" htmlFor='desc'>Description</label>
                                <input className="form-control" type='text' name='desc' required value={formData.desc} onChange={(e)=> setFormData({...formData, desc: e.target.value})}>
                                </input>
                              </div>
                              <div className="col-12 col-md-6">
                                <label className="form-label fw-medium" htmlFor='loc'>Lieu</label>
                                <input className="form-control" type='text' name='loc' required value={formData.loc} onChange={(e)=> setFormData({...formData, loc: e.target.value})}>
                                </input>
                              </div>
                              <div className="col-12 col-md-6">
                                <label className="form-label fw-medium" htmlFor='link'>Lien externe</label>
                                <input className="form-control" type='text' name='link' value={formData.link} onChange={(e)=> setFormData({...formData, link: e.target.value})}>
                                </input>
                              </div>
                            </div>
      
                            <div className="d-flex gap-2 mt-4">
                              <button type="submit" className="btn btn-primary">
                                {editingId ? "Modifier" : "Enregistrer"}
                              </button>
                              <button
                                type="button"
                                onClick={() => {
                                  setShowForm(false);
                                  setEditingId(null);
                                  setFormData({
                                    date: "",
                                    date_end: "",
                                    title: "",
                                    desc: "",
                                    loc: "",
                                    link: ""
                                  });
                                }}
                                className="btn btn-secondary"
                              >
                                Annuler
                              </button>
                            </div>
                          </form>
                        </div>
                      )}
                      <div className="row g-3 mt-4">
                        {upcoming.map((upcoming) => (
                          <div className="col-md-4 mb-3" key={upcoming.id}>
                                <div className={`card border-dark bg-white rounded shadow p-3 h-100`}>
                                  <div className="border-bottom pb-2 mb-2">
                                    <h2 className="h4 fw-bold">{upcoming.title}</h2>
                                    <h2 className="h5">{upcoming.desc}</h2>
                                    <p className="text-muted small mb-0">
                                      <Calendar size={16}/> {upcoming.date} 
                                        {upcoming.date_end && <> - {upcoming.date_end}</>}
                                    </p>
                                    <p className="text-muted small mb-0">
                                      <MapPin size={16}/> {upcoming.loc}
                                    </p>
                                    <p className="text-muted small mb-0">
                                      <Link size={16}/> {upcoming.link}
                                    </p>
                                  </div>

                                  <div className="d-flex gap-1">
                                    <button
                                                      onClick={() => editConcert(upcoming)}
                                                      className="btn btn-sm btn-outline-dark"
                                                      title="Modifier"
                                                    >
                                                      Modifier
                                                    </button>
                                                    <button
                                                      onClick={() => deleteConcert(upcoming.id)}
                                                      className="btn btn-sm btn-outline-dark"
                                                      title="Supprimer"
                                                    >
                                                      <X size={18} />
                                                    </button>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className="row g-3">
                        {past.map((concert) => (
                          <div className="col-md-4 mb-3" key={concert.id}>
                                <div className={`card border-dark bg-white rounded shadow p-3 h-100 ${past ? "opacity-50" : ""}`}>
                                  <div className="border-bottom pb-2 mb-2">
                                    {past && <span className="badge bg-secondary mb-2">Passé</span>}
                                    <h2 className="h4 fw-bold">{concert.title}</h2>
                                    <h2 className="h5">{concert.desc}</h2>
                                    <p className="text-muted small mb-0">
                                      <Calendar size={16}/> {concert.date} {concert.date_end && concert.date_end !== "0000-00-00" && (
                                                                              <> - {concert.date_end}</>
                                                                            )}
                                    </p>
                                    <p className="text-muted small mb-0">
                                      <MapPin size={16}/> {concert.loc}
                                    </p>
                                    <p className="text-muted small mb-0">
                                      <Link size={16}/> {concert.link}
                                    </p>
                                  </div>

                                  <div className="d-flex gap-1">
                                    <button
                                                      onClick={() => editConcert(concert)}
                                                      className="btn btn-sm btn-outline-dark"
                                                      title="Modifier"
                                                    >
                                                      Modifier
                                                    </button>
                                                    <button
                                                      onClick={() => deleteConcert(concert.id)}
                                                      className="btn btn-sm btn-outline-dark"
                                                      title="Supprimer"
                                                    >
                                                      <X size={18} />
                                                    </button>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>

                  </div>
                </div>
              </div>
    </section>
  );
}